import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import EmptyStackException from './EmptyStackException';
import IndexOutOfBoundsException from '../lang/IndexOutOfBoundsException';
import List from './List';

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/Stack.html
 */
var Stack = /*#__PURE__*/function (_List) {
  _inherits(Stack, _List);
  function Stack() {
    var _this;
    _classCallCheck(this, Stack);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stack).call(this));
    _this.array = [];
    return _this;
  }
  _createClass(Stack, [{
    key: "add",
    value: function add(e) {
      this.array.push(e);
      return true;
    }
  }, {
    key: "get",
    value: function get(index) {
      if (index < 0 || index >= this.size()) throw new IndexOutOfBoundsException();
      return this.array[index];
    }
    /**
     * Pushes an item onto the top of this stack.
     * @param {Object} e
     * @return {Object}
     */
  }, {
    key: "push",
    value: function push(e) {
      this.array.push(e);
      return e;
    }
    /**
     * Removes the object at the top of this stack and returns that object as the value of this function.
     * @return {Object}
     */
  }, {
    key: "pop",
    value: function pop() {
      if (this.array.length === 0) throw new EmptyStackException();
      return this.array.pop();
    }
    /**
     * Looks at the object at the top of this stack without removing it from the
     * stack.
     * @return {Object}
     */
  }, {
    key: "peek",
    value: function peek() {
      if (this.array.length === 0) throw new EmptyStackException();
      return this.array[this.array.length - 1];
    }
    /**
     * Tests if this stack is empty.
     * @return {boolean} true if and only if this stack contains no items; false
     *         otherwise.
     */
  }, {
    key: "empty",
    value: function empty() {
      return this.array.length === 0;
    }
    /**
     * @return {boolean}
     */
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.empty();
    }
    /**
     * Returns the 1-based position where an object is on this stack. If the object
     * o occurs as an item in this stack, this method returns the distance from the
     * top of the stack of the occurrence nearest the top of the stack; the topmost
     * item on the stack is considered to be at distance 1. The equals method is
     * used to compare o to the items in this stack.
     *
     * NOTE: does not currently actually use equals. (=== is used)
     *
     * @param {Object} o
     * @return {number} the 1-based position from the top of the stack where the
     *         object is located; the return value -1 indicates that the object is
     *         not on the stack.
     */
  }, {
    key: "search",
    value: function search(o) {
      return this.array.indexOf(o);
    }
    /**
     * @return {number}
     */
  }, {
    key: "size",
    value: function size() {
      return this.array.length;
    }
    /**
     * @return {Array}
     */
  }, {
    key: "toArray",
    value: function toArray() {
      return this.array.slice();
    }
  }]);
  return Stack;
}(List);
export { Stack as default };